import React from "react";

class Description extends React.Component {
    constructor(props) {
        super(props);

        _.map(["onChange"], fn => {
            this[fn] = this[fn].bind(this);
        });

        this.inputRef = React.createRef();
    }

    shouldComponentUpdate(nextProps) {
        if(!_.isEqual(nextProps.value, this.props.value) && nextProps.value === null) {
            this.inputRef.current.value = null;
        }

        if(!_.isEqual(nextProps.isUpdated, this.props.isUpdated) && nextProps.isUpdated) {
            this.inputRef.current.value = nextProps.value;
        }

        return true;
    }

    onChange(e) {
        if( this.props.onChange ) {
            this.props.onChange({ target: { id: "description", value: e.target.value } });
        }
    }

    render() {
        return (
            <input
                id="description"
                name="description"
                class="form-control"
                placeholder="Add Text Here"
                onChange={ this.onChange }
                ref={ this.inputRef }
            />
        )
    }
}

export default Description;
